import { trigger } from '@angular/animations';
import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReportService } from '../../services/report.service';
import { EncrdecrService } from '../../Auth/encrdecr.service';
import { isNullOrUndefined } from 'util';
import { environment } from '../../../environments/environment';
//import {DomToImage} from 'dom-to-image';
import * as saveAs from 'file-saver';
import html2canvas from 'html2canvas';
import { CustomLoaderService } from '../../services/custom-loader.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ArrayType } from '@angular/compiler';
import { ConfigService } from 'src/app/config.service';

declare var require: any;
const FileSaver = require('file-saver');
var domtoimage = require('dom-to-image');
declare var $: any;
@Component({
  selector: 'app-branding',
  templateUrl: './branding.component.html',
  styleUrls: ['./branding.component.scss']
})
export class BrandingComponent implements OnInit {
  SearchText: string;
  IsSubscribed = environment.IsSubscribed;
  @ViewChild('convertToImage', { static: true }) convertToImage: ElementRef;
  @ViewChild(' btn_download', { static: true }) btn_download: ElementRef;
  FilterForm: FormGroup;
  FilterFormSubmitted: boolean = false;
  G_SubBrokerId: string;
  G_LoginId: string;
  G_UserType: number = 2;
  G_EmpId: string;
  G_USER_ID: string;
  G_TransType: string;
  ProductList: any = [];
  CategoryList: any = [];
  TypeList: any = [];
  LogoStatus: boolean = false;
  DetailsStatus: boolean = false;
  ValueAdedList: any = [];
  CoBrandingData: any = [];
  imageUrl: string;
  Logourl: any;
  SubbrokerimageUrl: string;
  IsMobile: boolean = false;
  Name: string;
  Mobile: string;
  Email: string;
  MFDCompanyName: string;
  Website: string = window.location.host;
  ListimageUrl: string;
  CompanyName: string = environment.CompayName;
  ServerUrl: string = this.serverConfig.ServerUrl2;
  //dropdownlist
  SelectedClient: any[] = [];
  selectedItems = [];
  selectedItems1 = [];
  dropdownSettings = {};
  dropdownSettings1 = {};
  resultDisplayName: any[];
  result: any[];
  result1: any[];
  resultDisplayName1: any[];
  CheckNo: any;
  defaultName: string = 'Select category';
  withSlashesdate: string;
  withSlashesdatetemp: string;
  UploadedQR: string;
  AppName: string = '';
  LogoInterval: any;
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.SetViewPort(event.target.innerWidth);
  }
  constructor(
    private fb: FormBuilder,
    private reportservice: ReportService,
    private EncrdecrService: EncrdecrService,
    private route: ActivatedRoute,
    private router: Router,
    private Loader: CustomLoaderService,
    private serverConfig :ConfigService
  ) {
    this.FilterForm = fb.group({
      Product: ['0'],
      Category: ['0'],
      Type: [''],
      CheckFilter2: ['false'],
      CheckFilter1: ['false'],
      CheckFilter0: ['true']
    });
  }
  get f() {
    return this.FilterForm.controls;
  }
  ngOnInit() {
    debugger;
    this.SetViewPort(window.innerWidth);
    this.LogoInterval = setInterval(() => {
      if (this.Logourl == '' || isNullOrUndefined(this.Logourl)) {
        console.log('STILL INSIDE INTERVAL');
        if (environment.IsOptimoney) {
          this.Logourl = sessionStorage.getItem('pi4ZU2P3M8JE4q7');
        } else {
          this.Logourl =
            'data:image/jpg;base64,' + sessionStorage.getItem('lkighty445dh==');
        }
      } else {
        console.log('ENDED INTERVAL');
        if (environment.IsOptimoney) {
          this.Logourl = sessionStorage.getItem('pi4ZU2P3M8JE4q7');
        } else {
          this.Logourl =
            'data:image/jpg;base64,' + sessionStorage.getItem('lkighty445dh==');
        }
        clearInterval(this.LogoInterval);
      }

      // this.Loader.hide();
    }, 500);

    if (!isNullOrUndefined(sessionStorage.getItem('lkighty445dh==QR'))) {
      this.UploadedQR =
        'data:image/jpg;base64,' + sessionStorage.getItem('lkighty445dh==QR');
    }
    if (!isNullOrUndefined(sessionStorage.getItem('lkighty445dh==AppName'))) {
      this.AppName = sessionStorage.getItem('lkighty445dh==AppName');
    }

    let Cobranding = sessionStorage.getItem('Session_Cobranding');
    if (Cobranding != 'Y') {
      this.CallAlertModal_RedirectDashboard(
        'This feature is not available for you. Please contact support team for more info.'
      );
      // this.router.navigate(['/dashboard'], { relativeTo: this.route });
    } else {
      // setInterval(() => {
      //   this.Logourl = 'data:image/jpg;base64,'+ sessionStorage.getItem('lkighty445dh==');
      //   this.Loader.hide();
      // },500);

      $('.MainBg').css('min-height', window.innerHeight - 68);
      $(document).ready(function () {
        $('img.svg').each(function () {
          var $img = $(this);
          var imgID = $img.attr('id');
          var imgClass = $img.attr('class');
          var imgURL = $img.attr('src');

          $.get(
            imgURL,
            function (data) {
              // Get the SVG tag, ignore the rest
              var $svg = $(data).find('svg');

              // Add replaced image's ID to the new SVG
              if (typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
              }
              // Add replaced image's classes to the new SVG
              if (typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass + ' replaced-svg');
              }

              // Remove any invalid XML tags as per http://validator.w3.org
              $svg = $svg.removeAttr('xmlns:a');

              // Replace image with new SVG
              $img.replaceWith($svg);
            },
            'xml'
          );
        });
      });
      debugger;
      console.log('logo', sessionStorage.getItem('pi4ZU2P3M8JE4q7'));
      // this.Logourl =  'data:image/jpg;base64,'+ sessionStorage.getItem('pi4ZU2P3M8JE4q7');
      if (
        this.EncrdecrService.getDecr(
          sessionStorage.getItem('F44sGAGh2xwkpUL')
        ) != null
      ) {
        this.G_UserType = parseInt(
          this.EncrdecrService.getDecr(
            sessionStorage.getItem('L2D3506kIHSk3E0')
          )
        );
        if ((this.G_UserType = 2)) {
          this.G_SubBrokerId = this.EncrdecrService.getDecr(
            sessionStorage.getItem('F44sGAGh2xwkpUL')
          );
          this.G_EmpId = '';
          this.G_USER_ID = this.EncrdecrService.getDecr(
            sessionStorage.getItem('m5JkoXISmYRAIuY')
          );
          this.MFDCompanyName = sessionStorage.getItem('IDkcdnfjyysetr');
          this.Logourl =
            'data:image/jpg;base64,' + sessionStorage.getItem('lkighty445dh==');
        } else {
          this.G_EmpId = this.EncrdecrService.getDecr(
            sessionStorage.getItem('F44sGAGh2xwkpUL')
          );
          this.G_SubBrokerId = '';
          this.G_USER_ID = this.EncrdecrService.getDecr(
            sessionStorage.getItem('m5JkoXISmYRAIuY')
          );
        }
        this.G_LoginId = this.EncrdecrService.getDecr(
          sessionStorage.getItem('F44sGAGh2xwkpUL')
        );
        this.G_TransType = '';
      } else {
        console.log('Sesstion Timeout');
      }
      this.BindDropdon();

      //  this.dropdownSettings = {
      //   singleSelection: false,
      //   idField: "ProductId",
      //   textField: "ProductName",
      //   selectAllText: "Select All",
      //   unSelectAllText: "UnSelect All",
      //   itemsShowLimit: 1,
      //   allowSearchFilter: true,

      // };

      // this.dropdownSettings1 = {
      //   singleSelection: false,
      //   idField: "CategoryId",
      //   textField: "CategoryName",
      //   selectAllText: "Select All",
      //   unSelectAllText: "UnSelect All",
      //   itemsShowLimit: 1,
      //   allowSearchFilter: true,

      // };
    }
  }
  ngAfterViewInit() {
    $('#MainNAV .nav-item .nav-link').removeClass('active');
    $('#Id_ValueAdds .nav-link').addClass('active');
    $('select').select2();
    $('.DdlSelectProduct').on('change', (e: any) => this.onSelectProduct(e));
    $('.DdlSelectCategory').on('change', (e: any) => this.onSelectCategory(e));
    $('.DdlSelectType').on('change', (e: any) => this.onSelectType(e));
    $('.customselect1').on('select', (e: any) => this.onchangecheckstatus(0));
    $('.customselect0').on('select', (e: any) => this.onchangecheckstatus(1));
    $('.customselect2').on('select', (e: any) => this.onchangecheckstatus(2));
  }

  SetViewPort(w) {
    if (w <= 767) {
      this.IsMobile = true;
    } else {
      this.IsMobile = false;
    }
  }

  onchangecheckstatus(e: any) {
    debugger;
    switch (e) {
      case 0:
        this.FilterForm.controls['CheckFilter'].setValue('false');
        this.FilterForm.controls['CheckFilter1'].setValue('false');
        this.FilterForm.controls['CheckFilter0'].setValue('true');
        break;
      case 1:
        this.FilterForm.controls['CheckFilter'].setValue('false');
        this.FilterForm.controls['CheckFilter1'].setValue('true');
        this.FilterForm.controls['CheckFilter0'].setValue('false');
        break;
      case 2:
        this.FilterForm.controls['CheckFilter'].setValue('true');
        this.FilterForm.controls['CheckFilter1'].setValue('false');
        this.FilterForm.controls['CheckFilter0'].setValue('false');
        break;
    }
    this.CheckNo = e; //added by adarsh 20112023
  }

  onSelectProduct(event: any) {
    this.FilterForm.controls['Product'].setValue(event.target.value);
    this.FilterForm.controls['CheckFilter0'].setValue('false');
    this.FilterForm.controls['CheckFilter1'].setValue('false');

    let ProductId = event.target.value;

    if (ProductId != 0 || ProductId != '0') {
      this.reportservice
        .GetProductAndCatDropdown('Cat_BrandingList_pid', ProductId)
        .subscribe((data) => {
          this.CategoryList = data.ArrayOfResponse;
          this.ValueAdedList = this.CoBrandingData.filter(
            (arr) => arr.ProductId == this.f['Product'].value
          );
          this.f['Category'].setValue('0');
          this.defaultName = 'ALl';
        });
    } else {
      this.ValueAdedList = this.CoBrandingData;
    }
    // setTimeout(() => {
    //   if ( $.fn.DataTable.isDataTable('#brandingList') ) {
    //     $('#brandingList').DataTable().destroy();
    //     $(document).ready(function () {
    //    $('#brandingList').DataTable({

    //         "oLanguage": {
    //           "sEmptyTable": "No Record Found."
    //         },

    //         columnDefs: [
    //           { orderable: false, targets: "no-sort", },
    //           // { orderable : false, "targets": 0 }
    //         //   { type: 'extract-date', targets: [4]}
    //         ],
    //         //"order": [[0, 'asc'], [1, 'asc'], [2, ], [7, ], [9, ], [12, ], [13, ], [14, ]],
    //         pageLength: 10,
    //         bLengthChange: false,
    //         bFilter: true,
    //         language: {
    //           paginate: {
    //             next: '&#8594;', // or '→'
    //             previous: '&#8592;' // or '←'
    //           }
    //         },

    //       });
    //    })
    //   }
    //   else{
    //   $(document).ready(function () {
    //    $('#brandingList').DataTable({

    //       "oLanguage": {
    //         "sEmptyTable": "No Record Found."
    //       },

    //       columnDefs: [
    //         { orderable: false, targets: "no-sort", },
    //         // { orderable : false, "targets": 0 }
    //       //   { type: 'extract-date', targets: [4]}
    //       ],
    //       //"order": [[0, 'asc'], [1, 'asc'], [2, ], [7, ], [9, ], [12, ], [13, ], [14, ]],
    //       pageLength: 10,
    //       bLengthChange: false,
    //       bFilter: true,
    //       language: {
    //         paginate: {
    //           next: '&#8594;', // or '→'
    //           previous: '&#8592;' // or '←'
    //         }
    //       },

    //     });
    //  })

    // }
    // }, 1000);
  }
  onSelectCategory(event: any) {
    debugger;
    let CategoryId = event.target.value;
    this.FilterForm.controls['CheckFilter0'].setValue('false');
    this.FilterForm.controls['CheckFilter1'].setValue('false');

    if (CategoryId != 0 || CategoryId != '0') {
      console.log('categoryName', CategoryId);
      this.FilterForm.controls['Category'].setValue(event.target.value);
      //this.ValueAdedList  = this.CoBrandingData.filter( arr => arr.CategoryId == CategoryId );
      this.OnSubmitFilters();
    } else {
      this.ValueAdedList = this.CoBrandingData.filter(
        (arr) => arr.ProductId == this.f['Product'].value
      );
    }
  }
  onSelectType(event: any) {
    this.FilterForm.controls['Type'].setValue(event.target.value);
  }

  OnSubmitFilters() {
    debugger;
    this.FilterFormSubmitted = true;
    if (this.FilterForm.invalid) {
      return;
    } else {
      let tempValueAdedList = [];
      let temparrayofresp = [];

      let ProductId = this.FilterForm.controls['Product'].value;
      let CategoryName = this.FilterForm.controls['Category'].value;
      let Type = this.FilterForm.controls['Type'].value;
      // let ProductId =  '0';
      // let CategoryName =  "";
      // let Type =  "";

      this.reportservice
        .BindValueAddServiceData(
          'ValueSelect',
          ProductId,
          CategoryName,
          Type,
          this.G_USER_ID
        )
        .subscribe((data) => {
          // this.ValueAdedList = data.ArrayOfResponse;
          temparrayofresp = data.ArrayOfResponse;

          temparrayofresp.map((arr: any, index: number) => {
            if (arr.EventDate != null) {
              let newdate = new Date(arr.EventDate);
              let newmonth = newdate.getMonth() + 1;
              let newday = newdate.getDate();
              let withSlashes = [newday, newmonth].join('/');

              //arr.EventDate = withSlashes;
              this.withSlashesdatetemp = withSlashes;
              // console.log(tempValueAdedList); // 👉️ "2023/7/25"`
            } else {
              arr.EventDate = '';
            }
            const dataa = {
              ProductId: arr.ProductId,
              CategoryId: arr.CategoryId,
              ProductName: arr.ProductName,
              CategoryName: arr.CategoryName,
              BrandingWithEDL: arr.BrandingWithEDL,
              BrandingWithoutEDL: arr.BrandingWithoutEDL,
              EventDate: arr.EventDate,
              EventName: arr.EventName,
              FileType: arr.FileType,
              ValueAddID: arr.ValueAddID,
              FileNamewith: arr.FileNamewith,
              FileNamewithout: arr.FileNamewithout,
              SubBrokerId: arr.SubBrokerId,
              withSlashesdate: this.withSlashesdatetemp
            };

            tempValueAdedList.push(dataa);
          });
          console.log('tempValueAdedList', tempValueAdedList);
          this.ValueAdedList = tempValueAdedList;

          //  setTimeout(() => {
          //   if ( $.fn.DataTable.isDataTable('#brandingList') ) {
          //     $('#brandingList').DataTable().destroy();
          //     $('#brandingList').DataTable().empty();
          //     $(document).ready(function () {
          //    $('#brandingList').DataTable({

          //         "oLanguage": {
          //           "sEmptyTable": "No Record Found."
          //         },

          //         columnDefs: [
          //           { orderable: false, targets: "no-sort", },
          //           // { orderable : false, "targets": 0 }
          //         //   { type: 'extract-date', targets: [4]}
          //         ],
          //         //"order": [[0, 'asc'], [1, 'asc'], [2, ], [7, ], [9, ], [12, ], [13, ], [14, ]],
          //         pageLength: 10,
          //         bLengthChange: false,
          //         bFilter: true,
          //         language: {
          //           paginate: {
          //             next: '&#8594;', // or '→'
          //             previous: '&#8592;' // or '←'
          //           }
          //         },

          //       });
          //    })
          //   }
          //   else{
          //   $(document).ready(function () {
          //    $('#brandingList').DataTable({

          //       "oLanguage": {
          //         "sEmptyTable": "No Record Found."
          //       },

          //       columnDefs: [
          //         { orderable: false, targets: "no-sort", },
          //         // { orderable : false, "targets": 0 }
          //       //   { type: 'extract-date', targets: [4]}
          //       ],
          //       //"order": [[0, 'asc'], [1, 'asc'], [2, ], [7, ], [9, ], [12, ], [13, ], [14, ]],
          //       pageLength: 10,
          //       bLengthChange: false,
          //       bFilter: true,
          //       language: {
          //         paginate: {
          //           next: '&#8594;', // or '→'
          //           previous: '&#8592;' // or '←'
          //         }
          //       },

          //     });
          //  })

          // }
          // }, 1000);
        });
    }
  }
  onClickProceed(id: any, BrandingWithoutEDL: any, ValueAddID: any) {
    debugger;
    var srt = `#id_Logo_${id}`;
    if ($(`#id_Logo_${id}`).prop('checked')) {
      this.LogoStatus = true;
    }
    if ($(`#id_Details_${id}`).prop('checked')) {
      this.DetailsStatus = true;
    }

    if (this.LogoStatus == false && this.DetailsStatus == false) {
      this.CallAlertModal(
        'Please Select either logo or details before selecting Preview or Download'
      );
    } else {
      var DownloadSource = 'Web';
      var SUB_BROKER_CODE = this.G_USER_ID;
      var LogoChk = '';
      if (this.LogoStatus == true) {
        LogoChk = 'Yes';
      }
      var DetailChk = '';
      if (this.DetailsStatus == true) {
        DetailChk = 'Yes';
      }
      var EMP_ID = '';

      this.reportservice
        .CoBranding_GenerateLogo(
          BrandingWithoutEDL,
          ValueAddID,
          DownloadSource,
          SUB_BROKER_CODE,
          LogoChk,
          DetailChk,
          EMP_ID
        )
        .subscribe((data) => {
          console.log(data.ArrayOfResponse);
          debugger;

          this.imageUrl =
            'data:image/jpeg;base64,' +
            data.ArrayOfResponse[0].BrandingBase64Data;
        });
      if (isNullOrUndefined(this.imageUrl)) {
        this.imageUrl = sessionStorage.getItem('pi4ZU2P3M8JE4q7');
      }

      $('#CollateralsModal').modal({
        backdrop: 'static',
        keyboard: false
      });
    }
  }
  CallAlertModal(msg: any) {
    $('#AlertModal').modal({ backdrop: 'static', keyboard: false });
    $('#AlertModalContent').text(msg);
  }

  CallAlertModal_RedirectDashboard(msg: any) {
    $('#RedirectDashBoardModal').modal({ backdrop: 'static', keyboard: false });
    $('#RedirectDashBoardModalContent').text(msg);
  }
  BindDropdon() {
    debugger;
    this.reportservice
      .GetProductAndCatDropdown('Pd_BrandingList', '0')
      .subscribe((data) => {
        debugger;
        this.ProductList = data.ArrayOfResponse;
        //this.selectedItems = this.ProductList;
      });
    // this.reportservice.GetProductAndCatDropdown('Cat_BrandingList', '0').subscribe(data => {
    //   this.CategoryList = data.ArrayOfResponse;
    //   //this.selectedItems1 = this.CategoryList;
    // });
    // this.reportservice.BindType('FileType').subscribe(data => {
    //   this.TypeList = data.ArrayOfResponse;
    // });
    let ProductId = '0';
    let CategoryName = '';
    let Type = '';

    this.reportservice
      .BindValueAddServiceData(
        'ValueSelect',
        ProductId,
        CategoryName,
        Type,
        this.G_USER_ID
      )
      .subscribe((data) => {
        console.log('ValueAdedList');
        debugger;
        let tempValueAdedList = [];
        this.CoBrandingData = data.ArrayOfResponse;
        this.CoBrandingData.map((arr: any, index: number) => {
          const dataa = {
            ProductId: arr.ProductId,
            CategoryId: arr.CategoryId,
            ProductName: arr.ProductName,
            CategoryName: arr.CategoryName,
            BrandingWithEDL: arr.BrandingWithEDL,
            BrandingWithoutEDL: arr.BrandingWithoutEDL,
            EventDate: arr.EventDate,
            EventName: arr.EventName,
            FileType: arr.FileType,
            ValueAddID: arr.ValueAddID,
            FileNamewith: arr.FileNamewith,
            FileNamewithout: arr.FileNamewithout,
            SubBrokerId: arr.SubBrokerId,
            withSlashesdate: ''
          };
          tempValueAdedList.push(dataa);
        });
        this.CoBrandingData = tempValueAdedList;

        //      $(document).ready(function () {
        //       debugger;
        //       $.fn.dataTable.ext.errMode = 'none';

        //       //======================Report tab
        //       $.fn.dataTable.ext.errMode = 'none';
        // // //Added by ROHAN
        // // $.extend($.fn.dataTableExt.oSort, {
        // //   "extract-date-pre": function (value) {
        // //     debugger
        // //     var date = $(value, 'span')[0].innerHTML;
        // //     date = date.split('/');
        // //     return Date.parse(date[1] + '/' + date[0] + '/' + date[2]) //mm/dd/yyyy
        // //   },
        // //   "extract-date-asc": function (a, b) {
        // //     return ((a < b) ? -1 : ((a > b) ? 1 : 0));
        // //   },
        // //   "extract-date-desc": function (a, b) {
        // //     return ((a < b) ? 1 : ((a > b) ? -1 : 0));
        // //   }
        // // });
        // // //////
        //       var tables = $('#brandingList').DataTable({

        //         "oLanguage": {
        //           "sEmptyTable": "No Record Found."
        //         },

        //         columnDefs: [
        //           { orderable: false, targets: "no-sort", },
        //           // { orderable : false, "targets": 0 }
        //         //   { type: 'extract-date', targets: [4]}
        //         ],
        //         //"order": [[0, 'asc'], [1, 'asc'], [2, ], [7, ], [9, ], [12, ], [13, ], [14, ]],
        //         pageLength: 10,
        //         bLengthChange: false,
        //         bFilter: true,
        //         language: {
        //           paginate: {
        //             next: '&#8594;', // or '→'
        //             previous: '&#8592;' // or '←'
        //           }
        //         },

        //       });
        //     });
        //         tempValueAdedList.map((arr: any, index: number) => {
        //           if(arr.EventDate != null){
        //             let newdate = new Date(arr.EventDate)
        //             let newmonth = newdate.getMonth() + 1;
        //             let newday = newdate.getDate();
        //             let withSlashes = [newmonth, newday].join('/');
        //             arr.EventDate = withSlashes;
        //             console.log(withSlashes); // 👉️ "2023/7/25"`
        //           }
        //           else{
        //             arr.EventDate = '';
        //           }
        //         });
        //         const todaydate = new Date();
        //         const year = todaydate.getFullYear();
        //         const month = todaydate.getMonth() + 1;
        //         const day = todaydate.getDate();

        // const todaywithSlashes = [day,month].join('/');
        // console.log(todaywithSlashes); // 👉️ "2023/7/25"
        //         this.ValueAdedList = tempValueAdedList.filter( arr => arr.EventDate == todaywithSlashes );
        this.checkForTodayAll('0');
        console.log(data.ArrayOfResponse);
      });

    this.reportservice
      .BindValueAddServiceData(
        'SubBrokerLogo',
        ProductId,
        CategoryName,
        Type,
        this.G_USER_ID
      )
      .subscribe((data) => {
        console.log(data.ArrayOfResponse);
        if (data.ArrayOfResponse.length > 0) {
          // this.SubbrokerimageUrl =data.ArrayOfResponse[0].BrandingBase64Data;
          // console.log(this.SubbrokerimageUrl);
          //this.Name=data.ArrayOfResponse[0].SubBrokerName;
          //this.Mobile=data.ArrayOfResponse[0].CoBrandingSBMobile;
          // this.Email=data.ArrayOfResponse[0].EmailID;
        }
        //console.log(data.ArrayOfResponse);
      });
    if (
      isNullOrUndefined(this.Name) ||
      isNullOrUndefined(this.Mobile) ||
      isNullOrUndefined(this.Email)
    ) {
      this.Name = this.EncrdecrService.getDecr(
        sessionStorage.getItem('V4WGROuLLBE6t98')
      ); //Session_UserName;
      this.Email = this.EncrdecrService.getDecr(
        sessionStorage.getItem('V8hpPfITcxhEI9x')
      ); //Session_UserEmail;
      this.Mobile = this.EncrdecrService.getDecr(
        sessionStorage.getItem('Xe003SRRyYEoOC2')
      ); //Session_UserMobile
    }
    this.Loader.hide();
  }

  //added by adarsh 08112023
  checkForTodayAll(t: string) {
    debugger;
    let returnvalue = [];
    //if(t == "1"){
    let e = [];
    if (this.f['Product'].value == '0' || this.f['Category'].value == '0') {
      e =
        this.ValueAdedList.length > 0
          ? this.ValueAdedList
          : this.CoBrandingData;
    } else {
      if (this.f['Category'].value != '0') {
        e =
          this.ValueAdedList.length > 0
            ? this.ValueAdedList
            : this.CoBrandingData.filter(
                (arr) =>
                  arr.ProductId == this.f['Product'].value &&
                  arr.CategoryId == this.f['Category'].value
              );
      } else {
        e =
          this.ValueAdedList.length > 0
            ? this.ValueAdedList
            : this.CoBrandingData.filter(
                (arr) =>
                  arr.ProductId == this.f['Product'].value ||
                  arr.CategoryId == this.f['Category'].value
              );
      }
    }
    let tempValueAdedList = e;
    tempValueAdedList.map((arr: any, index: number) => {
      if (arr.EventDate != null) {
        let newdate = new Date(arr.EventDate);
        let newmonth = newdate.getMonth() + 1;
        let newday = newdate.getDate();
        let withSlashes = [newday, newmonth].join('/');

        //arr.EventDate = withSlashes;
        arr.withSlashesdate = withSlashes;
        // console.log(tempValueAdedList); // 👉️ "2023/7/25"`
      } else {
        arr.EventDate = '';
      }
    });
    const todaydate = new Date();
    const year = todaydate.getFullYear();
    const month = todaydate.getMonth() + 1;
    const day = todaydate.getDate();

    let todaywithSlashes = [day, month].join('/');
    console.log(todaywithSlashes); // 👉️ "2023/7/25"
    if (t == '1') {
      // this.FilterForm.controls['Category'].setValue('');
      returnvalue = tempValueAdedList.filter(
        (arr) => arr.withSlashesdate.toString() == todaywithSlashes.toString()
      );
      this.ValueAdedList = returnvalue;
    } else if (t == '0') {
      // todaywithSlashes = [day,month,year].join('/');
      // let today_date = new Date(todaywithSlashes);
      // this.FilterForm.controls['Category'].setValue('');
      var todaydate_ = todaywithSlashes;
      var today_date = todaydate_.split('/');

      tempValueAdedList.map((arr: any, index: number) => {
        //let event_date = new Date(arr.EventDate);
        var eventdate = arr.withSlashesdate;
        var event_date = eventdate.split('/');
        // if((today_date[1] == event_date[1] ||  event_date[1] > today_date[1])&& (today_date[0] == event_date[0] ||  event_date[0] >= today_date[0] ))
        // {
        //   returnvalue.push(arr)
        // }
        if (
          parseInt(today_date[1]) == parseInt(event_date[1]) ||
          parseInt(event_date[1]) > parseInt(today_date[1])
        ) {
          if (
            parseInt(today_date[0]) == parseInt(event_date[0]) ||
            parseInt(event_date[0]) > parseInt(today_date[0])
          ) {
            returnvalue.push(arr);
          } else if (
            parseInt(event_date[1]) > parseInt(today_date[1]) &&
            parseInt(event_date[0]) < parseInt(today_date[0])
          ) {
            returnvalue.push(arr);
          }
        }
      });
    } else {
      this.FilterForm.controls['Category'].setValue('');
      this.ValueAdedList = this.CoBrandingData;
    }
    if (this.f['Product'].value == '0' || this.f['Category'].value == '0') {
      this.ValueAdedList = returnvalue;
    } else {
      if (this.f['Category'].value != '0') {
        this.ValueAdedList = returnvalue.filter(
          (arr) =>
            arr.ProductId == this.f['Product'].value &&
            arr.CategoryId == this.f['Category'].value
        );
      } else {
        this.ValueAdedList = returnvalue.filter(
          (arr) =>
            arr.ProductId == this.f['Product'].value ||
            arr.CategoryId == this.f['Category'].value
        );
      }
    }
    // }
    // else{
    //   this.ValueAdedList = this.CoBrandingData ;

    // }
  }

  onClickPreview() {
    $('#ModelPreview').modal({ backdrop: 'static', keyboard: false });
  }

  onClickDownload() {
    console.log('onClickDownload');
    FileSaver.saveAs(this.imageUrl, `BrandingWithEDL.jpeg`);
  }
  //Added by adarsh
  downloadToPng() {
    //  debugger;

    // var ImgData = this.convertToImage.nativeElement.innerHTML;

    // var options = {
    //     quality: 0.95
    // };

    // debugger;
    //  domtoimage.toPng(ImgData,options).then((data)=>{
    //      var link = document.createElement("a");
    //      link.download = "my_image.png";
    //      link.href = data;
    //      link.click();

    //    });

    // })
    debugger;
    //   var canvas = this.convertToImage.nativeElement.innerHTML;
    // domtoimage.toBlob(function(blob) {
    //    saveAs(blob, "pretty image.png");
    // });

    // var canvas = document.getElementById("my-canvas");
    // canvas.toBlob(function(blob) {
    //     saveAs(blob, "BrandingImage.png");
    // });
    html2canvas(document.getElementById('convertToImage'), {
      useCORS: true,
      allowTaint: true,
      scrollY: 0
    }).then((canvas) => {
      canvas.toBlob(function (blob) {
        saveAs(blob, 'BrandingImage.png');
      });
    });
  }

  onListPreview(url: any) {
    debugger;
    this.reportservice.CoBranding_GenerateLogoInByte(url).subscribe((data) => {
      console.log('onListPreview');
      if (data.ArrayOfResponse.length > 0) {
        this.ListimageUrl = data.ArrayOfResponse[0].BrandingWithEDL;
        $('#ModelListPreview').modal({ backdrop: 'static', keyboard: false });
        // this.downloadToPng();
      } else {
        this.CallAlertModal('File not Found');
      }
    });
  }
  onListDownload(url: any, FileNamewith: any) {
    this.reportservice.CoBranding_GenerateLogoInByte(url).subscribe((data) => {
      console.log('onListDownload');

      if (data.ArrayOfResponse.length > 0) {
        this.ListimageUrl = data.ArrayOfResponse[0].BrandingWithEDL;
        FileSaver.saveAs(this.ListimageUrl, FileNamewith);
      } else {
        this.CallAlertModal('File not Found');
      }
    });
  }

  // onItemSelectDeselectAll(items: any, para: number) {
  //   ////
  //   //let clientName = items.TEXTFIELD;
  //   switch (para) {
  //     case 0:
  //       this.result = [];
  //       this.resultDisplayName = [];
  //       this.resultDisplayName.push("All");
  //       items.map((item) => {
  //         this.result.push(item.VALUEFIELD);
  //       });
  //       break;
  //     case 1:
  //       this.result = [];
  //       this.resultDisplayName = [];
  //       break;
  //   }

  //   this.f["Product"].setValue(
  //     this.result.toString()
  //   );
  // }

  // onItemSelect(e: any) {
  //   ////
  //   debugger;
  //   let ProductId = e.VALUEFIELD;
  //   let ProductName = e.TEXTFIELD;

  //   if (ProductId) {
  //     let i = this.result.indexOf(ProductId);
  //     if (i == -1) {
  //       if (this.result.length > 0) {
  //         this.resultDisplayName = [];
  //         this.resultDisplayName.push("Multiple");
  //       } else {
  //         this.resultDisplayName.push(ProductName);
  //       }
  //       this.result.push(ProductId);
  //     } else {
  //       this.result.splice(i, 1);
  //       this.resultDisplayName.splice(i, 1);
  //       if (this.result.length > 1) {
  //         this.resultDisplayName = [];
  //         this.resultDisplayName.push("Multiple");
  //       } else {
  //         this.resultDisplayName = [];
  //         this.resultDisplayName.push(this.selectedItems[0].TEXTFIELD);
  //       }
  //     }

  //     this.f["Product"].setValue(
  //       this.result.toString()
  //     );
  //   }
  // }

  // onItemSelectDeselectAll1(items: any, para: number) {
  //   ////
  //   //let clientName = items.TEXTFIELD;
  //   switch (para) {
  //     case 0:
  //       this.result = [];
  //       this.resultDisplayName1 = [];
  //       this.resultDisplayName1.push("All");
  //       items.map((item) => {
  //         this.result.push(item.VALUEFIELD);
  //       });
  //       break;
  //     case 1:
  //       this.result1 = [];
  //       this.resultDisplayName1 = [];
  //       break;
  //   }

  //   this.f["Category"].setValue(
  //     this.result.toString()
  //   );
  // }

  // onItemSelect1(e: any) {
  //   ////
  //   debugger;
  //   let CategoryId = e.VALUEFIELD;
  //   let CategoryName = e.TEXTFIELD;

  //   if (CategoryId) {
  //     let i = this.result.indexOf(CategoryId);
  //     if (i == -1) {
  //       if (this.result.length > 0) {
  //         this.resultDisplayName1 = [];
  //         this.resultDisplayName1.push("Multiple");
  //       } else {
  //         this.resultDisplayName.push(CategoryName);
  //       }
  //       this.result.push(CategoryId);
  //     } else {
  //       this.result.splice(i, 1);
  //       this.resultDisplayName.splice(i, 1);
  //       if (this.result.length > 1) {
  //         this.resultDisplayName = [];
  //         this.resultDisplayName.push("Multiple");
  //       } else {
  //         this.resultDisplayName = [];
  //         this.resultDisplayName.push(this.selectedItems1[0].TEXTFIELD);
  //       }
  //     }

  //     this.f["Category"].setValue(
  //       this.result.toString()
  //     );
  //   }
  // }
}
